import { z } from 'zod';

const envSchema = z.object({
  REACT_APP_API_BASE_URL: z
    .string({ required_error: 'REACT_APP_API_BASE_URL is required' })
    .url('REACT_APP_API_BASE_URL must be a valid URL'),
  REACT_APP_GOOGLE_CLIENT_ID: z.string().optional(),
  NODE_ENV: z.enum(['development', 'production', 'test']).default('development'),
});

function validateEnv() {
  const result = envSchema.safeParse(process.env);
  if (!result.success) {
    const formatted = result.error.issues
      .map((issue) => `  - ${issue.path.join('.')}: ${issue.message}`)
      .join('\n');
    console.error(`Environment validation failed:\n${formatted}`);
    return {
      REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:8090',
      REACT_APP_GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      NODE_ENV: (process.env.NODE_ENV ?? 'development') as 'development' | 'production' | 'test',
    };
  }
  return result.data;
}

export const env = validateEnv();
